//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import skPlayer from '../lib/skPlayer.js';
import '../css/skPlayer.scss'

import axios from 'axios'
export default {
    data() {
            return {
                "zhuan": true,
                "appear": true,
                afterlyric: [],
                time: null,
                currentIndex: -1,
                i: 0
            }
        },
        computed: {
            songlist() {
                return this.$store.getters.getRecord
            },
            test(){//设置默认的第一张封面
                return this.$store.getters.getRecord[0].cover 
            },
            recordCover() {
                return this.$store.getters.getrecordCover
            },
            lyric() {
                let i = this.i
                return this.$store.getters.getRecord[i].lyric
            }

        },
        filters: {
            lyric(val) {
                val = val.replace(/\[\d{2}:\d{2}.\d{2}\]/g, '');
                return val
            }
        },
        methods: {
            back() {
                window.history.back()
            },
            parseLyric(lyric) {
                //歌词时间转换处理;
                // 以行为单位拆分每一句歌词
                // 将每句歌词的时间tag和内容分离
                // 将时间转换为分钟
                let lines = lyric.split('\n');
                let pattern = /\[\d{2}:\d{2}.\d{2}\]/g;
                let result = [];
                while (!pattern.test(lines[0])) {
                    lines = lines.slice(1);
                }
                lines[lines.length - 1].length === 0 && lines.pop();
                for (let data of lines) {
                    let index = data.indexOf(']');
                    let time = data.substring(0, index + 1);
                    let value = data.substring(index + 1);
                    let timeString = time.substring(1, time.length - 2);
                    let timeArr = timeString.split(':');
                    result.push([Math.floor(timeArr[0], 10) * 60 + Math.floor(timeArr[1]), value]);
                }
                result.sort(function(a, b) {
                    return a[0] - b[0];
                });
                return result;
            }
        },
        mounted() {
            //--------接收唱片信息; new 一个播放器;
            var songlist = this.$store.getters.getRecord
            var player = new skPlayer({
                listshow: false,
                music: {
                    type: 'file',
                    source: songlist
                }
            });
            player.play();

            //-------init------初始化------
            var audio = document.querySelector('.skPlayer-source');
            var kPlayer = document.querySelector('.skPlayer-play-btn')
            var self = this
            var list = document.querySelectorAll('.skPlayer-list li')

            // ------methods-------方法
            //封面停止与播放与播放按钮互相绑定
            kPlayer.onclick = function() {
                if (audio.paused) {
                    self.zhuan = false
                } else {
                    self.zhuan = true
                }
            };
            //点击列表的切换事件; 
            for (let i = 0; i < list.length; i++) {
                list[i].onclick = function() {
                    //1.切换封面
                    setTimeout(function() {
                            var imgHead = document.querySelector('.skPlayer-cover');
                            self.$store.dispatch('setrecordCover', imgHead.src);

                        }, 300)
                        //补上转动的封面
                    if (audio.paused) {
                        self.zhuan = true
                    } else {
                        self.zhuan = true
                    }
                    //2.切换歌词
                    self.i = i
                    self.afterlyric = self.parseLyric(self.lyric)
                }
            }



            //------歌词的同步
            //1.转换歌词格式
            let lyric = this.parseLyric(this.lyric);
            this.afterlyric = lyric;
                //console.log(this.afrerlyric)  //处理后的歌词格式;
                //2.获取当前audio时间,并且将时间与歌词绑定对应;
            audio.ontimeupdate = function() {
                let playtime = Math.floor(audio.currentTime);
                let currentIndex = 0
                for (let i = 0; i < self.afterlyric.length; i++) {
                    if (playtime === self.afterlyric[i][0]) {
                        self.currentIndex = i;
                    }
                }

            };
            //3.歌词的滚动效果 :style控制top值;

            //----广告的隐藏 
            var ad = document.querySelector('.skPlayer-list-switch')
            ad.onclick = function() {

                if (self.appear) {
                    self.appear = false;
                } else {
                    self.appear = true;
                }
            }
        },
        watch:{
            afterlyric:function(val){
                this.afterlyric = val
                 console.log(this.afterlyric)  //待解决的问题;切换歌词的同步;
            },
            test:function(val){
                console.log('test',val)
            }        
        }
}



// WEBPACK FOOTER //
// ./src/views/song.vue